// extracted by mini-css-extract-plugin
export default {"root":"CxgSTFmtKklz0ZhXqnvA","panel":"zNHBWRWOAni4jmEOmTQQ"};